import React from "react";
import { Link } from "@sscs/ui";
import { getRouteBasename } from "Utils";
import styles from "./supportLoginLink.module.scss";

const basename = getRouteBasename();

const SupportLoginLink = (): React.JSX.Element => {
  return (
    <Link className={styles.text} href={`${basename}/login/support`} inline>
      Support login
    </Link>
  );
};

export default SupportLoginLink;
